import * as React from "react";

import { aiClient, aiRouter } from "@v1/trpc/routes/ai";
import {
  componentTemplatesClient,
  componentTemplatesRouter,
} from "@v1/trpc/routes/componentTemplates";
import {
  designLibraryClient,
  designLibraryRouter,
} from "@v1/trpc/routes/designLibrary";
import { folderClient, folderRouter } from "@v1/trpc/routes/folder";
import {
  funnelTemplateClient,
  funnelTemplateRouter,
} from "@v1/trpc/routes/funnelTemplate";
import { shopifyClient, shopifyRouter } from "@v1/trpc/routes/shopify";
import { storeClient, storeRouter } from "@v1/trpc/routes/store";
import { swatchClient, swatchRouter } from "@v1/trpc/routes/swatch";
import { getNamespacedQueryClient } from "@v2/trpc/trpc";

/**
 * Wraps children with all TRPC-related providers required by the V1 editor.
 */
export function V1TRPCProviders({ children }: React.PropsWithChildren) {
  return (
    <aiRouter.Provider
      client={aiClient}
      queryClient={getNamespacedQueryClient("ai")}
    >
      <componentTemplatesRouter.Provider
        client={componentTemplatesClient}
        queryClient={getNamespacedQueryClient("componentTemplates")}
      >
        <designLibraryRouter.Provider
          client={designLibraryClient}
          queryClient={getNamespacedQueryClient("designLibrary")}
        >
          <folderRouter.Provider
            client={folderClient}
            queryClient={getNamespacedQueryClient("folder")}
          >
            <funnelTemplateRouter.Provider
              client={funnelTemplateClient}
              queryClient={getNamespacedQueryClient("funnelTemplate")}
            >
              <shopifyRouter.Provider
                client={shopifyClient}
                queryClient={getNamespacedQueryClient("shopify")}
              >
                <storeRouter.Provider
                  client={storeClient}
                  queryClient={getNamespacedQueryClient("store")}
                >
                  <swatchRouter.Provider
                    client={swatchClient}
                    queryClient={getNamespacedQueryClient("swatch")}
                  >
                    {children}
                  </swatchRouter.Provider>
                </storeRouter.Provider>
              </shopifyRouter.Provider>
            </funnelTemplateRouter.Provider>
          </folderRouter.Provider>
        </designLibraryRouter.Provider>
      </componentTemplatesRouter.Provider>
    </aiRouter.Provider>
  );
}
